'use client';

import styled from 'styled-components';
import PulseLoader from 'react-spinners/PulseLoader';
import { useTranslations } from 'next-intl';
import { useGlobalContext } from '@/context/context';
import { calendarPalette as palette } from './calendar-stuff/CalendarPalette';

const LogoutScreen = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
  background: ${palette.canvas};
  color: ${palette.ink};
`;

export default function LogoutBoundary({ children }) {
  const { isLoggingOut } = useGlobalContext();
  const t = useTranslations('CalendarDesign');

  if (!isLoggingOut) return children;

  return (
    <LogoutScreen role="status" aria-live="polite">
      <PulseLoader color={palette.accentInk} aria-hidden="true" />
      <p>{t('SigningOut')}</p>
    </LogoutScreen>
  );
}
